export default __webpack_public_path__ + "static/media/qandelbrc.eeb593da.png";